import {
    breakpoints as bp
} from '../vars/breakpoints';

const setScaling = () => {
    const $html = document.querySelector('html');
    const $style = $html.appendChild(document.createElement('style'));
    const rem = 16;

    const setFontRange = (fromW, toW, percentFrom, percentTo) => {
        const sizeFrom = rem * percentFrom;
        const sizeTo = rem * percentTo;
        const percent = (sizeTo - sizeFrom) / (toW - fromW);

        return `
            font-size: clamp(
                ${sizeFrom}px,
                calc(${sizeFrom}px + ${percent} * 100 * 1vw - ${percent} * ${fromW}px),
                ${sizeTo}px
            );
        `;
    }

    const setFontScale = (bpFrom, bpTo) => {
        const fromW = bp[bpFrom];
        const toW = bp[bpTo];
        const scaleUp = fromW < toW;
        const scale = toW / fromW;

        if (scaleUp) {
            return setFontRange(fromW, toW, 1, scale);
        } else {
            return setFontRange(toW, fromW, scale, 1);
        }
    }

    $style.textContent = `
        :root {
            font-size:${rem * 0.66}px;

            @media (min-width: ${bp['mobile-xs']}px) {
                ${setFontScale('design-mobile', 'mobile-xs')}
            }

            @media (min-width: ${bp['design-mobile']}px) {
                ${setFontScale('design-mobile', 'tablet-sm')}
            }

            @media (min-width: ${bp['tablet-sm']}px) {
                ${setFontScale('design-tablet', 'tablet-sm')}
            }

            @media (min-width: ${bp['design-tablet']}px) {
                ${setFontScale('design-tablet', 'desktop-sm')}
            }

            @media (min-width: ${bp['desktop-sm']}px) {
                ${setFontScale('design-desktop', 'desktop-sm')}
            }

            @media (min-width: ${bp['design-desktop']}px) {
                ${setFontScale('design-desktop', 'max')}
            }
        }
    `;
}

document.addEventListener('DOMContentLoaded', setScaling);

export default setScaling;
